import { useEffect } from 'react';

import { ErrorStates, useBulkCreateContext } from '../providers/BulkCreateContextProvider.tsx';
import { useMappingsState } from '../providers/BulkConfigureContextProvider.tsx';

export const useManualBulkCreateState = (): {
	isLoading: boolean;
	isError: boolean;
	isIdle: boolean;
} => {
	const [
		{
			currentJiraSite,
			currentJiraProject,
			currentDefaultIssueType,
			manualCreateState,
			error,
			bulkIssuesList,
		},
		actions,
	] = useBulkCreateContext();

	const { loadingIssueTypeFields } = useMappingsState();

	useEffect(() => {
		const isLoading =
			!currentJiraSite ||
			!currentJiraProject ||
			!currentDefaultIssueType ||
			loadingIssueTypeFields ||
			bulkIssuesList?.length === 0;
		if (isLoading) {
			void actions.setManualCreateState('loading');
		}

		const isError = error !== ErrorStates.EMPTY;
		if (isError) {
			void actions.setManualCreateState('error');
		}

		if (!isLoading && !isError) {
			void actions.setManualCreateState('idle');
		}
	}, [
		actions,
		currentDefaultIssueType,
		currentJiraProject,
		currentJiraSite,
		loadingIssueTypeFields,
		error,
		bulkIssuesList,
	]);

	return {
		isLoading: manualCreateState === 'loading',
		isError: manualCreateState === 'error',
		isIdle: manualCreateState === 'idle',
	};
};
